// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__12fnp","selected":"Chip_selected__rB4j5"};